import ResultShow from "@/components/atomic/atoms/ResultShow";
import SearchSelect from "@/components/atomic/atoms/SearchSelect";
import { PV_SELECT_OPTION } from "@/types/PresenterModel/PV_SELECT_OPTION";
import "./index.css";

type Props<T> = {
  inputKeyword: string;
  onInputKeywordChange: (v: string) => void;
  onSelect: (v: PV_SELECT_OPTION<T> | null) => void;
  list: Array<PV_SELECT_OPTION<T>>;
  selectedItem: PV_SELECT_OPTION<T> | null;
  needClear: boolean;
  selectorFontClass?: string;
  resultFontClass?: string;
  dataType: string;
  clearText: string;
  showResult?: boolean;
  needDelete?: boolean;
  onDelete?: (v: PV_SELECT_OPTION<T> | null) => void;
  disabled?: boolean;
};

export default function SearchSelectResult<T = string>({
  list,
  selectedItem,
  onInputKeywordChange,
  inputKeyword,
  onSelect,
  needClear,
  selectorFontClass,
  resultFontClass,
  dataType,
  clearText,
  showResult,
  needDelete,
  onDelete,
  disabled
}: Props<T>) {
  return (
    <div className="atomic molecules search-select-result">
      <SearchSelect<T>
        onDelete={onDelete}
        needDelete={needDelete}
        needClear={needClear}
        className="mr-1"
        list={list}
        inputKeyword={inputKeyword}
        onInputKeywordChange={onInputKeywordChange}
        onSelect={onSelect}
        dataType={dataType}
        selectorFontClass={selectorFontClass}
        clearText={clearText}
        disabled={disabled}
      />
      {showResult && (
        <ResultShow
          value={selectedItem?.resultLabel ?? selectedItem?.longLabel ?? ""}
          resultFontClass={resultFontClass}
          clearText={clearText}
        />
      )}
    </div>
  );
}
